import { gql } from "@apollo/client";

export const GET_BUSCAR_PACIENTES = gql`
query GetPacientesSearch($filter: PacienteSearchFilterInput!) {
  pacientesSearch(filter: $filter) {
    success
    error
    valorEsperado {
      idPaciente
      delegacion
      estado
      tipoDocumento
      numeroDocumento
      nombre
      apellido
      fechaNacimiento
      edad
      idCliente
      cliente
      numeroAfiliado
      codSAPPaciente
    }
  }
}`;
